module.exports = __webpack_public_path__ + "img/mediale_sx.40535100.png";